import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'
import { toast } from 'sonner'
import type { HttpErrorResponse } from '@/types/error'
import ModalPopup from '@/components/ui/ModalPopup'
import useMyBookingMutation from '@/hooks/useMyBookingMutation'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/my-booking/list/$id/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })

  const { deleteBooking } = useMyBookingMutation()

  const onConfirm = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      toast.promise(deleteBooking.mutateAsync({ id: bookingId }), {
        loading: 'Loading...',
        success: () => {
          router.history.back()
          return '1 saved booking removed successfully'
        },
        error: async (err) => {
          if (isHttpError<HttpErrorResponse>(err)) {
            const res = await err.response.json()
            return 'message' in res ? res.message : res.error
          }
          return 'Something went wrong. Please try again.'
        },
      })
    },
    [router],
  )

  return (
    <ModalPopup
      opened
      onClose={() => router.history.back()}
      onConfirm={onConfirm}
      title="Remove Saved Booking?"
      description="Are you sure you want to remove this saved booking? This action cannot be undone."
      confirmLabel="Remove Booking"
      bgColor="#D21C1C"
    />
  )
}
